<template>
    <div v-if="this.product.product_type_id === 2 || image.src" class="product-image" :class="image.class">
        <img v-if="this.product.product_type_id !== 2" :src="image.src" :alt="product.title" :title="product.title" v-for="count in image.quantity" :key="count">
        <img v-else :src="item.resource.paths['original']" :alt="item.title" :title="item.title" v-for="item in product.bundles" :key="item.id">
    </div>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object
            },
            variant: {
                type: Object
            },
            singleClass: {
                type: String
            },
            bundleClass: {
                type: String
            }
        },
        computed: {
            image() {
                let image = {
                    quantity: null,
                    src: null,
                    class: null
                }

                if ( this.product.product_type_id === 1 ) image = {
                    quantity: [1],
                    src: this.product.resource ? this.product.resource.paths['original'] : null,
                    class: this.singleClass ? this.singleClass : 'product-image-big'
                }

                if ( this.product.product_type_id === 2 ) image = {
                    quantity: null,
                    src: null,
                    class: `product-image-bundle-${this.product.bundles.length} ${this.bundleClass ? this.bundleClass : 'listing-bundle-image'}`
                }

                if ( this.product.product_type_id === 3 ) image = {
                    quantity: [1, 2, 3, 4, 5],
                    src: this.product.bundles.length && this.product.bundles[0].resource ? this.product.bundles[0].resource.paths['original'] : null,
                    class: `product-image-bundle-5 ${this.bundleClass ? this.bundleClass : 'listing-bundle-image'}`
                }

                if ( this.product.product_type_id === 4 ) image = {
                    quantity: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    src: this.product.bundles.length && this.product.bundles[0].resource ? this.product.bundles[0].resource.paths['original'] : null,
                    class: `product-image-bundle-10 ${this.bundleClass ? this.bundleClass : 'listing-bundle-image'}`
                }

                if ( this.product.product_type_id === 5 ) image = {
                    quantity: [1],
                    src: this.variant && this.variant.resource ? this.variant.resource.paths['original'] : this.product.resource ? this.product.resource.paths['original'] : null,
                    class: this.singleClass ? this.singleClass : 'product-image-big'
                }

                return image
            }
        }
    }
</script>